/**
 * @author czy
 * 功能：查询采购结算待查询
 */

import { Service } from '@/tools'

export class OutInBatchDetailService<T extends TSettle.OutInBatchDetail> extends Service {
  constructor(path: string) {
    super()
    this.setPathPrefix(path)
  }

  private post2<P extends TCommon.ApiVersion = 'v1'>(url: `${P}/${keyof TSettle.OutInBatchDetail}`, data?: TCommon.Json, toast?: string) {
    return this.post(url, data, toast)
  }

  // 查询采购结算待查询第一层列表/api/settle/outInBatchDetail/v1/page
  page = <K extends T['ApiPage']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiPage', data)

  // 查询采购结算待查询第二层列表/api/settle/outInBatchDetail/v1/pageToSettleList
  pageToSettleList = <K extends T['ApiPageToSettleList']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiPageToSettleList', data)

  // 查询采购结算待查询第三层列表/api/settle/outInBatchDetail/v1/pageToSettleListDetail
  pageToSettleListDetail = <K extends T['ApiPageToSettleListDetail']>(data: K['req']): Promise<K['res']> =>
    this.post2('v1/ApiPageToSettleListDetail', data)

  // 查询收发货单据列表接口 /api/settle/outInBatchDetail/v1/getOutInBatchDetailBusinessDocument
  getOutInBatchDetailBusinessDocument = <K extends T['ApiGetOutInBatchDetailBusinessDocument']>(data: K['req']): Promise<K['res']> =>
    this.post2('v1/ApiGetOutInBatchDetailBusinessDocument', data)

  // 查询发货批次明细 接口地址：/api/settle/outInBatchDetail/v1/getGoodsDetailPageDTO
  getGoodsDetailPageDTO = <K extends T['ApiGetGoodsDetailPageDTO']>(data: K['req']): Promise<K['res']> =>
    this.post2('v1/ApiGetGoodsDetailPageDTO', data)
  //销售中心查询未结算收发货单
  getSellOrderNotSettleDTO = <K extends T['ApiGetSellOrderNotSettleDTO']>(data: K['req']): Promise<K['res']> =>
    this.post2('v1/ApiGetSellOrderNotSettleDTO', data)
  // 业务单进项-销项结算信息分页查询
  // /api/settle/outInBatchDetail/v1/pageOutInBatchDetailList
  pageOutInBatchDetailList = <K extends T['ApiPageOutInBatchDetailList']>(data: K['req']): Promise<K['res']> =>
    this.post2('v1/ApiPageOutInBatchDetailList', data)
  // 业务单关联进项-销项结算单查询
  // /api/settle/outInBatchDetail/v1/getOutInBatchDetailCommodityList
  getOutInBatchDetailCommodityList = <K extends T['ApiGetOutInBatchDetailCommodityList']>(data: K['req']): Promise<K['res']> =>
    this.post2('v1/ApiGetOutInBatchDetailCommodityList', data)
}
